import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Table, TableCell, TableContainer, TableRow, TableHead, TableBody, Box, FormControl, Button, CircularProgress } from '@mui/material';
import { getEquipmentStatusesByQuery } from "components/axios/equipmentAxios";
import { getEquipmentCategoriesByQuery } from "components/axios/equipmentCategoryAxios";
// import { getStationsByQuery } from "components/axios/stationAxios";
// import { getWorkingPartsByQuery } from "components/axios/workingPartAxios";
import { getEquipmentStatusBasicItemsByQuery, getEquipmentStatusItemsByQuery } from "components/axios/equipmentStatusItemsAxios";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import CommonExcelDownload from "components/CommonExcelDownload";
import CustomEnumSelect from "components/select/CustomEnumSelect";
import { useEnumApi } from 'contexts/EnumApiContext';
import PageInfo from "components/PageInfo";
import CustomSelect from "components/select/CustomSelect";

const EquipmentPerformanceStatusReportDataroomStatusReport = () => {
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
               // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const [isLoading, setIsLoading] = useState(false);

    let [pageInfo, setPageInfo] = useState({});
    let [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const handlePaging = (value) => {
        value = isNaN(value) ? 1 : value;
        setCurrentPage(value-1);
    }

    const separate = "___";
    // const [workingParts, setWorkingParts] = useState([]);
    // const [stations, setStations] = useState([]);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);

    // const [subwayCode, setSubwayCode] = useState('');
    // const [workingPartId, setWorkingPartId] = useState('');
    // const [stationId, setStationId] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
  
    const [reportTitle, setReportTitle] = useState("");

    const [excelTopHeaderBasicObjects, setExcelTopHeaderBasicObjects] = useState([]);
    const [excelTopHeaderObjects, setExcelTopHeaderObjects] = useState([]);
    const [excelTopHeaders, setExcelTopHeaders] = useState([]);
    const [fileName, setFileName] = useState("");
    const [reports, setReports] = useState([]);
    const [excelDatas, setExcelDatas] = useState([]);

    // 호선 선택시 해당 파트 목록 가져오기
    // useEffect(()=>{
    //     if (subwayCode) {
    //         const param = {"subwayLine" : subwayCode, size:50}
    //         getWorkingPartsByQuery(param).then((data)=>{
    //             if (data && data._embedded) {
    //                 let workingParts = data._embedded.workingParts;
    //                 setWorkingParts(workingParts);
    //             } else {
    //                 setWorkingParts([]);
    //             }
    //             setStations([]);
    //         });
    //     }
    // },[subwayCode]);

    // // 파트 선택시 해당 역사 목록 가져오기
    // useEffect(()=>{
    //     if (workingPartId) {
    //         const param = {"workingPart.id" : workingPartId, sort:"code,asc", size:50};
    //         getStationsByQuery(param).then((data)=>{
    //             if (data && data._embedded) {
    //                 setStations(data._embedded.stations);
    //             } else {
    //                 setStations([]);
    //             }
    //         });
    //     }
    // },[workingPartId]);

    // 설비중분류 목록
    useEffect(()=>{
        if (equipmentCategoryLevel1Id) {
            const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentCategories;
                    if (list) {
                        setEquipmentCategoryLevel2s(list);
                    } else {
                        setEquipmentCategoryLevel2s([]);
                    }
                } else {
                    setEquipmentCategoryLevel2s([]);
                }
                setEquipmentCategoryLevel3s([]);
            });
        }
    },[equipmentCategoryLevel1Id]);

    // 설비분류 목록
    useEffect(()=>{
        if (equipmentCategoryLevel2Id) {
            const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                const list = data._embedded.equipmentCategories;
                    if (list) {
                        setEquipmentCategoryLevel3s(list);
                    } else {
                        setEquipmentCategoryLevel3s([]);
                    }
                } else {
                    setEquipmentCategoryLevel3s([]);
                }
            });
        }
    },[equipmentCategoryLevel2Id]);

    // 설비분류 목록
    useEffect(()=>{
        if (equipmentCategoryLevel3Id) {
            const param = { "equipmentCtgr.id": equipmentCategoryLevel3Id, size : 100, sort : "id,asc"};
            Promise.all([
                getEquipmentStatusBasicItemsByQuery(param).then((data) => {
                    if (data && data._embedded) {
                        const list = data._embedded.equipmentStatusBasicItems;
                        if (list) {
                            return list;
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                }),
                getEquipmentStatusItemsByQuery(param).then((data) => {
                    if (data && data._embedded) {
                        const list = data._embedded.equipmentStatusItems;
                        if (list) {
                            return list;
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                })
            ]).then((res)=>{
                let excelTopHeaderCopys = [
                    // t('message.common.subtitle.subwayline'), t('message.common.subtitle.workingPart'), t('message.common.subtitle.station'), 
                    t('message.common.subtitle.equipment.name'), t('message.common.subtitle.equipment.number')];
                let excelTopHeaderObjects = [];
                if (res[0] && res[0].length > 0) {   // 기본현황
                    res[0].map(function(basic) {
                        excelTopHeaderCopys.push(basic.itemNm);
                        excelTopHeaderObjects.push(basic.id);
                    })
                }
                setExcelTopHeaderBasicObjects(excelTopHeaderObjects);
                excelTopHeaderObjects = [];
                if (res[1] && res[1].length > 0) {   // 성능현황
                    res[1].map(function(item) {
                        let itemNames = item.itemNm ? item.itemNm.split(separate) : "_________".split(separate);
                        let itemName = itemNames[0].trim() + (itemNames[0].trim() && itemNames[1].trim() && ("|")) + itemNames[1].trim() + (itemNames[1].trim() && itemNames[2].trim() && ("|")) + itemNames[2].trim();
                        excelTopHeaderCopys.push(itemName);
                        excelTopHeaderObjects.push(item.id);
                    })
                }
                setExcelTopHeaderObjects(excelTopHeaderObjects);
                setExcelTopHeaders(excelTopHeaderCopys)
            })
        }
    },[equipmentCategoryLevel3Id]);
    
    const selectParam = () => {
        if (equipmentCategoryLevel1Id === null || equipmentCategoryLevel1Id === '') {
            alertMessage = t('message.common.alert.level1.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (equipmentCategoryLevel2Id === null || equipmentCategoryLevel2Id === '') {
            alertMessage = t('message.common.alert.level2.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (equipmentCategoryLevel3Id === null || equipmentCategoryLevel3Id === '') {
            alertMessage = t('message.common.alert.level3.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }
        setIsLoading(true);
        reportList(0);
    }

    useEffect(()=> {
        if (isLoading && !isNaN(currentPage) && (excelTopHeaderBasicObjects || excelTopHeaderObjects) && (equipmentCategoryLevel1Id !== null && equipmentCategoryLevel1Id !== '') 
            && (equipmentCategoryLevel2Id !== null && equipmentCategoryLevel2Id !== '') && (equipmentCategoryLevel3Id !== null && equipmentCategoryLevel3Id !== '')) {
            reportList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, isLoading, excelTopHeaderBasicObjects, excelTopHeaderObjects, equipmentCategoryLevel1Id, equipmentCategoryLevel2Id, equipmentCategoryLevel3Id]);

    function reportList(curPage=currentPage) {
        isNaN(curPage) && setCurrentPage(0);
        isNaN(pageSize) && setPageSize(50);
        let param = {
            page: curPage,
            size : pageSize,
        };

        // if (subwayCode) {
        //     param['equipment.station.workingPart.subwayLine'] = subwayCode;
        // }
        // if (workingPartId) {
        //     param['equipment.station.workingPart.id'] = workingPartId;
        // }
        // if (stationId) {
        //     param['equipment.station.id'] = stationId;
        // }
        if (equipmentCategoryLevel3Id) {
            param['equipment.equipmentCtgr.id'] = equipmentCategoryLevel3Id;
        }
        
        let reportTitle = t('menu.cmms.report-dataroom.status-report.equipment-performance-status');
        setReportTitle(reportTitle);
        setFileName(reportTitle+"_"+Date.now());

        Promise.all([
            getEquipmentStatusesByQuery(param).then((data) => {
                if (data != null) {
                    if (data.page) {
                        setPageInfo(data.page);
                    } else {
                        setCurrentPage(0);
                        pageInfo = {
                            size: pageInfo.size,
                            totalElements: 0,
                            totalPages: 0,
                            number: 0
                        };
                        setPageInfo(pageInfo);
                    }
                    if (data._embedded) {
                        let list = data._embedded.equipmentStatuses;
                        if (list) {
                            let excelDatas = [];
                            let excelData = [];
                            list && list.forEach(function (column, a) {
                                excelData = [
                                    // ((column.equipment.station && getEnumValueByEnumNameAndCode("SubwayLine", column.equipment.station.workingPart.subwayLine)[0].title) || ''),
                                    // ((column.equipment.station && column.equipment.station.workingPart.name) || ''),
                                    // ((column.equipment.station && column.equipment.station.name) || ''),
                                    ((column.equipment && column.equipment.name) || ''),
                                    ((column.equipment && column.equipment.equipmentNo) || ''),
                                ];

                                excelTopHeaderBasicObjects && excelTopHeaderBasicObjects.map(function(header) {
                                    const object = column.basicItems && column.basicItems.find(item => header == item.itemId)
                                    if (object)
                                        excelData.push(object.value)
                                    else
                                        excelData.push('')
                                })

                                excelTopHeaderObjects && excelTopHeaderObjects.map(function(header) {
                                    const object = column.statusItems && column.statusItems.find(item => header == item.itemId)
                                    if (object)
                                        excelData.push(object.value)
                                    else
                                        excelData.push('')
                                })
                                
                                excelDatas.push(excelData);
                            });
                            setReports(excelDatas);
                            return data.page.totalElements;
                        } else {
                            setReports([]);
                            return 0;
                        }
                    } else {
                        setReports([]);
                        return 0;
                    }
                }
            })
        ]).then((res)=>{
            delete param.page;
            param.page = 0;
            const totalCount = res[0];
            if (totalCount > 0) {
                param.size = totalCount;
                getEquipmentStatusesByQuery(param).then((data) => {
                    if (data && data._embedded) {
                        let list = data._embedded.equipmentStatuses;
                        if (list) {
                            let excelDatas = [];
                            let excelData = [];
                            list && list.forEach(function (column, a) {
                                excelData = [
                                    // ((column.equipment.station && getEnumValueByEnumNameAndCode("SubwayLine", column.equipment.station.workingPart.subwayLine)[0].title) || ''),
                                    // ((column.equipment.station && column.equipment.station.workingPart.name) || ''),
                                    // ((column.equipment.station && column.equipment.station.name) || ''),
                                    ((column.equipment && column.equipment.name) || ''),
                                    ((column.equipment && column.equipment.equipmentNo) || ''),
                                ];

                                excelTopHeaderBasicObjects && excelTopHeaderBasicObjects.map(function(header) {
                                    const object = column.basicItems && column.basicItems.find(item => header == item.itemId)
                                    if (object)
                                        excelData.push(object.value)
                                    else
                                        excelData.push('')
                                })

                                excelTopHeaderObjects && excelTopHeaderObjects.map(function(header) {
                                    const object = column.statusItems && column.statusItems.find(item => header == item.itemId)
                                    if (object)
                                        excelData.push(object.value)
                                    else
                                        excelData.push('')
                                })
                                
                                excelDatas.push(excelData);
                            });
                            setExcelDatas(excelDatas);
                        } else {
                            setExcelDatas([]);
                        }
                    } else {
                        setExcelDatas([]);
                    }
                })
            } else {
                setExcelDatas([]);
            }
        })
        setIsLoading(false);
    }

    return (
        <div style={{color:"#000"}}>
            <Box sx={{ minWidth: 120 }}>
                {/* {getEnumValueByEnumName("SubwayLine") && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                        key={subwayCode}
                        label={t('message.common.subtitle.subwayline')}
                        labelName={t('message.common.subtitle.subwayline')}
                        name={'subway'}
                        defaultValue={subwayCode}
                        onChange={(e)=>{
                            setSubwayCode(e.target.value);
                            setWorkingPartId('');
                            setStationId('');
                            setIsLoading(false);
                        }}
                        list={getEnumValueByEnumName("SubwayLine")}
                    />
                </FormControl>
                }
                {workingParts && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                <CustomSelect
                    key={workingPartId}
                    label={t('message.common.subtitle.workingPart')}
                    labelName={t('message.common.subtitle.workingPart')}
                    name={'workPart'}
                    defaultValue={workingPartId}
                    onChange={(e)=>{
                        setWorkingPartId(e.target.value);
                        setStationId('');
                        setIsLoading(false);
                    }}
                    list={workingParts}
                />
                </FormControl>
                }
                {stations && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                <CustomSelect
                    key={stationId}
                    label={t('message.common.subtitle.station')}
                    labelName={t('message.common.subtitle.station')}
                    name={'station'}
                    defaultValue={stationId}
                    onChange={(e)=>{
                        setStationId(e.target.value);
                        setIsLoading(false);
                    }}
                    list={stations}
                />
                </FormControl>
                } */}
                {equipmentCategoryLevel1s && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                        key={equipmentCategoryLevel1Id}
                        label={t('message.common.subtitle.equipment.level1')}
                        labelName={t('message.common.subtitle.equipment.level1')}
                        name={'level1'}
                        defaultValue={equipmentCategoryLevel1Id}
                        onChange={(e)=>{
                            setEquipmentCategoryLevel1Id(e.target.value);
                            setEquipmentCategoryLevel2Id('');
                            setEquipmentCategoryLevel3Id('');
                            setIsLoading(false);
                        }}
                        list={equipmentCategoryLevel1s}
                    />
                </FormControl>
                }
                {equipmentCategoryLevel2s && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                        key={equipmentCategoryLevel2Id}
                        label={t('message.common.subtitle.equipment.level2')}
                        labelName={t('message.common.subtitle.equipment.level2')}
                        name={'level2'}
                        defaultValue={equipmentCategoryLevel2Id}
                        onChange={(e)=>{
                            setEquipmentCategoryLevel2Id(e.target.value);
                            setEquipmentCategoryLevel3Id('');
                            setIsLoading(false);
                        }}
                        list={equipmentCategoryLevel2s}
                    />
                </FormControl>
                }
                {equipmentCategoryLevel3s && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                        key={equipmentCategoryLevel3Id}
                        label={t('message.common.subtitle.equipment.level3')}
                        labelName={t('message.common.subtitle.equipment.level3')}
                        name={'level3'}
                        defaultValue={equipmentCategoryLevel3Id}
                        onChange={(e)=>{
                            setEquipmentCategoryLevel3Id(e.target.value);
                            setIsLoading(false);
                        }}
                        list={equipmentCategoryLevel3s}
                    />
                </FormControl>
                }
                
                <Link to={''}><Button variant="contained" style={{marginTop:"13px",padding:"5px 15px"}} onClick={selectParam}>{t('message.common.btn.report.generation')}</Button></Link>
            </Box>

            {reportTitle &&
            <div>
                <p className="report-dataroom-tit">
                    {reportTitle}
                </p>

                <div className="scrollbar">
                    <TableContainer>
                        <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table fix_table">
                            <TableHead>
                                <TableRow>
                                    {excelTopHeaders && excelTopHeaders.map((header,i)=> {
                                        return (
                                    <TableCell key={i}>{header}</TableCell>    
                                        )
                                    })}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                            { reports && reports.map(function(items, i) {
                                return (
                                <TableRow key={i}>
                                {items && items.map((item, j)=> {
                                    return (
                                    <TableCell key={j}>{item}</TableCell>
                                    )
                                })}
                                </TableRow>
                                )
                            })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <br/>

                {(excelDatas && excelDatas.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page'>
                        <CommonExcelDownload excelDatas={excelDatas} excelHeader={excelTopHeaders} title={`${reportTitle}`} filename={`${fileName}.xlsx`} />
                    </div>
                </div>
                :
                (reports && reports.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page' style={{color:"#000"}}>
                        <Box sx={{ display: 'flex', color:"#000" }}>
                            {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                        </Box>
                    </div>
                </div>
                : ''
                }

                <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>

            </div>
            }
        </div>
    )

}

export default EquipmentPerformanceStatusReportDataroomStatusReport;